import React from 'react';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PropTypes from 'prop-types';
import VideoTags from './VideoTags';
import VideoActions from './VideoAction';
import VideoTrailer from './VideoTrailer';
import useResize from '../hooks/useResize';
import VideoReaction from './VideoReaction';

function VideoDescription({ selectedVideo, setCurrentVideo, isPromo = false, onUnlockFullLibrary }) {
	const deviceType = useResize();
	return (
		<div className="c-video_description">
			<div className="">
				<div className="c-video_description-h4">
					<h1>{selectedVideo?.title}</h1>
					<VideoReaction videoId={selectedVideo?._id} localOnly={isPromo}/>
				</div>

				
				<div className={isPromo ? 'promo-video-details-row' : undefined}>
					<div className="promo-video-details-main">
						<div className="video-info-container">
							<div>
								{selectedVideo?.instructor && (
									<div className="video-instructor">
										<PersonOutlineIcon style={{ fontSize: deviceType == 'mobile' ? '24px' : '30px', color: '#008BC3' }} />
										<p>{selectedVideo?.instructor}</p>
									</div>
								)}
							</div>
							{!isPromo && <VideoTrailer selectedVideo={selectedVideo} setCurrentVideo={setCurrentVideo} />}
						</div>
						<div className="c-video_description-tag">
							<VideoTags tags={selectedVideo?.tagsDetails} />
							{!isPromo && <VideoActions video={selectedVideo} />}
						</div>
					</div>
					{isPromo && <VideoActions video={selectedVideo} isPromo={isPromo} onUnlockFullLibrary={onUnlockFullLibrary} />}
				</div>
			</div>
		</div>
	);
}

export default VideoDescription;



VideoDescription.propTypes = {
	selectedVideo: PropTypes.shape({
		title: PropTypes.string,
		tagsDetails: PropTypes.arrayOf(
			PropTypes.shape({
				_id: PropTypes.string,
				name: PropTypes.string,
				color: PropTypes.string,
				priority: PropTypes.number
			})
		),
		description: PropTypes.string
	}),
	isPromo: PropTypes.bool,
	onUnlockFullLibrary: PropTypes.func
};
